import React from "react";
import { motion } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const ProductImageGallery = ({
  selectedImage,
  selectedImageIndex,
  productImages,
  handleThumbnailClick,
  handleFullScreenClick,
  navigateImage,
}) => {
  return (
    <div className="relative space-y-4 flex justify-center items-center flex-col">
      {/* Main Image */}
      <motion.div
        key={selectedImage}
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
        className="relative"
      >
        <div
          onClick={() => handleFullScreenClick(selectedImage)}
          onKeyUp={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              handleFullScreenClick(selectedImage);
            }
          }}
          className="w-full flex items-center justify-center cursor-pointer rounded-lg"
        >
          {/* Mobile view */}
          <div className="md:hidden h-[90vw] sm:h-[400px] flex items-center justify-center">
            <img
              src={selectedImage}
              alt={productImages[selectedImageIndex].alt}
              className="max-w-full max-h-full object-contain  [box-shadow:0_0_15px_#a4a4a4]"
            />
          </div>

          {/* Desktop view */}
          <div className="hidden md:flex h-[500px] items-center justify-center">
            <img
              src={selectedImage}
              alt={productImages[selectedImageIndex].alt}
              className="max-w-full max-h-full object-contain [box-shadow:0_0_15px_#a4a4a4]"
            />
          </div>
        </div>

        {/* Navigation Arrows */}
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            navigateImage(-1);
          }}
          className="absolute left-0 sm:left-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-1.5 sm:p-2 rounded-full shadow-lg transition-all"
        >
          <ChevronLeft className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" />
        </button>
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            navigateImage(1);
          }}
          className="absolute right-0 sm:right-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-1.5 sm:p-2 rounded-full shadow-lg transition-all"
        >
          <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" />
        </button>
      </motion.div>

      {/* Thumbnail Images - Mobile: Scrollable row */}
      <div className="block xl:hidden relative w-full">
        <div className="overflow-x-auto w-[90vw] md:w-[36.5vw] py-3 no-scrollbar -mx-4 px-4">
          <div className="flex gap-0 pb-2">
            {productImages.map((image, index) => (
              <motion.div
                key={image.id}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => handleThumbnailClick(image.src, index)}
                className="cursor-pointer rounded-lg w-16 h-16 sm:w-20 sm:h-20 flex-shrink-0 transition-all flex items-center justify-center "
              >
                <div className="w-full h-full p-1 flex items-center justify-center">
                  <img
                    src={image.src}
                    alt={productImages[selectedImageIndex].alt}
                    className="w-full h-full object-contain [box-shadow:0_0_8px_#cccc]"
                  />
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      {/* Thumbnail Images - Desktop: 8 columns */}
      <div className="hidden  justify-center xl:grid grid-cols-8 gap-[7px] ">
        {productImages.map((image, index) => (
          <motion.div
            key={image.id}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => handleThumbnailClick(image.src, index)}
            className="w-14 h-14 p-0"
          >
            <img
              src={image.src}
              alt={productImages[selectedImageIndex].alt}
              className="w-14 h-14 [box-shadow:0_0_8px_#cccc]"
            />
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProductImageGallery;
